import { render, staticRenderFns } from "./categoryTree.vue?vue&type=template&id=94ae79ea&scoped=true"
import script from "./categoryTree.vue?vue&type=script&lang=js"
export * from "./categoryTree.vue?vue&type=script&lang=js"
import style0 from "./categoryTree.vue?vue&type=style&index=0&id=94ae79ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ae79ea",
  null
  
)

export default component.exports